import { usePackagingListContext } from "../PackagingListContext";
import { AutoGrid } from "src/components/Grid/layout/AutoGrid";
import { useTranslation } from "react-i18next";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import type { HTMLAttributes, ReactNode } from "react";

type PackagingsGridProps = {
    viewTabsLeading?: ReactNode;
    tablePanelProps?: Pick<HTMLAttributes<HTMLDivElement>, "id" | "role" | "aria-labelledby">;
};

const PackagingsGrid = (props: PackagingsGridProps) => {
    const { viewTabsLeading, tablePanelProps } = props;
    const { t } = useTranslation();
    const isProductUxV2 = useIsProductUxV2();
    const {
        mrt_columns,
        gridKey,
        gridConfiguration,
        appSearch,
        menuItems,
        tableActions,
        packagings = [],
        isReady,
        isRefetching,
        totalItems,
        pagination,
        activeTab,
    } = usePackagingListContext();

    const isLoading = isReady === false || isRefetching === true;

    return (
        <AutoGrid
            key={activeTab}
            {...(isProductUxV2 && {
                actionHeader: t("common.actions", "Actions"),
                appearance: "hub" as const,
                emptyMessage: t("no_packaging_added"),
                enableViews: true,
                mobileTableMode: "scroll" as const,
            })}
            enableColumnsAction
            viewTabsLeading={viewTabsLeading}
            tablePanelProps={tablePanelProps}
            gridKey={gridKey}
            columns={mrt_columns}
            data={packagings}
            isLoading={isLoading}
            totalItems={totalItems}
            searchParams={appSearch}
            menuItems={menuItems}
            tableActions={tableActions}
            columnsConfig={gridConfiguration}
            pagination={pagination}
        />
    );
};
export default PackagingsGrid;
